import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicGroupsContractValue({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 120 80"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g clipPath="url(#pic_groups_contract-value_svg__a)">
        <path
          opacity={0.2}
          d="M70.94 52.58c2.51 7.09-4.28 23.1-23.23 22.78-11.87 0-35-12.5-35.26-24.9-.25-12.41 11.66-15.3 24.46-7.97 12.8 7.34 27.56-8.2 34.03 10.09zm37.4-.31c-1.45 2.58-4.62 2.94-9.7 2.45-3.82-.37-7.3-.66-11.13-2.74a21.4 21.4 0 01-6.34-5.35c-1.67-2.07-4.01-4.44-2.87-6.8 1.58-3.23 10.69-5.95 19.53-1.5 9.72 4.9 11.93 11.41 10.51 13.94z"
          fill="#62B9F7"
        />
        <path
          d="M36 13c0-1.1.9-2 2-2h34.57L84 22.43V65a2 2 0 01-2 2H38a2 2 0 01-2-2V13z"
          fill="#fff"
          filter="url(#pic_groups_contract-value_svg__b)"
        />
        <path opacity={0.5} d="M72.57 11L84 22.43h-9.43a2 2 0 01-2-2V11z" fill="#A3CBE7" />
        <path
          d="M45 23.57h18m-18 6h18m-18 6h30m-30 6h30m-30 6h30M45 54h30"
          stroke="#E3E8E8"
          strokeWidth={2}
          strokeLinecap="round"
        />
        <g filter="url(#pic_groups_contract-value_svg__c)">
          <circle cx={87} cy={60} r={12} fill="#0C8BE6" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M85.08 64.27l-3.9-3.9a.6.6 0 010-.85l.84-.84a.6.6 0 01.85 0l2.63 2.62 5.63-5.62a.6.6 0 01.85 0l.84.84a.6.6 0 010 .85l-6.9 6.9a.6.6 0 01-.84 0z"
            fill="#fff"
          />
        </g>
        <path
          d="M36.39 1.47a1 1 0 011.22 0L40.87 4a1 1 0 00.64.2l4.12-.12a1 1 0 011 .72l1.14 3.96a1 1 0 00.4.54l3.4 2.32a1 1 0 01.38 1.16l-1.39 3.88a1 1 0 000 .68l1.4 3.88a1 1 0 01-.38 1.16l-3.41 2.32a1 1 0 00-.4.54l-1.15 3.96a1 1 0 01-.99.72l-4.12-.13a1 1 0 00-.64.21l-3.26 2.53a1 1 0 01-1.22 0L33.13 30a1 1 0 00-.64-.2l-4.12.12a1 1 0 01-1-.72l-1.14-3.96a1 1 0 00-.4-.54l-3.4-2.32a1 1 0 01-.38-1.16l1.39-3.88a1 1 0 000-.68l-1.4-3.88a1 1 0 01.38-1.16l3.41-2.32a1 1 0 00.4-.54l1.15-3.96a1 1 0 01.99-.72l4.12.13a1 1 0 00.64-.21l3.26-2.53z"
          fill="#FB8F23"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.89 13.82a8.4 8.4 0 00-11.05-4.38 8.4 8.4 0 106.64 15.41 8.4 8.4 0 004.4-11.03zM33.25 8.06a9.9 9.9 0 0113.01 5.17 9.9 9.9 0 11-18.2 7.83 9.9 9.9 0 015.2-13"
          fill="#FFE266"
        />
        <path
          d="M37.74 22.06v1.22a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5v-1.1c-1-.05-1.95-.29-2.56-.59-.11-.05-.2-.17-.17-.3l.32-1.33a.25.25 0 01.14-.17.25.25 0 01.21 0c.63.3 1.45.55 2.34.55.9 0 1.51-.35 1.51-.98 0-.6-.5-.97-1.67-1.37-1.69-.57-2.82-1.35-2.82-2.88 0-1.4 1.2-2.48 2.7-2.81v-1c0-.28.22-.5.5-.5h.5c.27 0 .5.22.5.5v.89c1 .04 1.58.21 2.08.43.11.05.18.17.14.3l-.32 1.28a.26.26 0 01-.35.17 4.95 4.95 0 00-2-.42c-1.03 0-1.36.45-1.36.89 0 .52.55.85 1.9 1.35 1.87.67 2.67 1.53 2.67 2.95 0 1.4-1.27 2.6-2.76 2.92z"
          fill="#FFE266"
        />
      </g>
      <defs>
        <filter
          id="pic_groups_contract-value_svg__b"
          x={28}
          y={5}
          width={64}
          height={72}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1230_22595" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1230_22595" result="shape" />
        </filter>
        <filter
          id="pic_groups_contract-value_svg__c"
          x={67}
          y={42}
          width={40}
          height={40}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1230_22595" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1230_22595" result="shape" />
        </filter>
        <clipPath id="pic_groups_contract-value_svg__a">
          <path fill="#fff" d="M0 0h120v80H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

SvgPicGroupsContractValue.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicGroupsContractValue.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicGroupsContractValue svgRef={ref} {...props} />
));
export default ForwardRef;
